import { render, staticRenderFns } from "./feedback-list.vue?vue&type=template&id=1bc2aad6&scoped=true"
import script from "./feedback-list.vue?vue&type=script&lang=js"
export * from "./feedback-list.vue?vue&type=script&lang=js"
import style0 from "./feedback-list.vue?vue&type=style&index=0&id=1bc2aad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc2aad6",
  null
  
)

export default component.exports